import ApiService from '../api.services';

const ContractService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/contracts');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/contracts/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form, cardpost) {
        const data = {
            contract: form
        }
        data.contract.cardpost = cardpost;
        try {
            const response = await ApiService.post('/api/contracts', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form, cardpost) {
        const data = {
            contract: form
        }
        data.cardpost = cardpost;
        try {
            const response = await ApiService.put(`/api/contracts/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/contracts/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    validate: async function (body) {
        try {
            const response = await ApiService.post(`/api/contracts/validate`, body);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ContractService;

export { ContractService };

